import React from 'react';
import BigNumber from 'bignumber.js';
import { useQuery } from 'react-query';
import { useSelector } from 'react-redux';
import { Container, Grid, Box, Typography } from '@mui/material';

import CustomButton from '../../components/CustomButton';

import imgFarm from '../../assets/images/farm.png';
import imgThor from '../../assets/images/LeftBar/Bitmap.png';

import styles from './style.module.css';

import { pools } from '../../utils/farm';
import {
  useGetPendingTHOR,
  useGetTotalStaked,
  useWithdraw,
  useGetAllowance,
  useGetUserInfo,
  useGetTotalSupply,
} from '../../hooks/farm';
import { getNumber } from '../../utils/utils';

const useTVL = (ethereum) => {
  const lpPool = pools[0];
  const thorPool = pools[1];

  const lpStaked = useGetTotalStaked(lpPool.address);
  const thorStaked = useGetTotalStaked(thorPool.address);

  const lpPrice = useQuery(
    ['lpPrice', lpPool.pid, lpPool.symbol],
    () => {
      return lpPool.getPrice(ethereum);
    },
    {
      refetchInterval: 60000 * 10,
      enabled: Boolean(ethereum),
    },
  );
  const thorPrice = useQuery(
    ['lpPrice', thorPool.pid, thorPool.symbol],
    () => {
      return thorPool.getPrice(ethereum);
    },
    {
      refetchInterval: 60000 * 10,
      enabled: Boolean(ethereum),
    },
  );

  const isLoaded = [lpPrice.data, lpStaked, thorPrice.data, thorStaked].every(Boolean);

  const tvl = isLoaded
    ? Number(getNumber(lpStaked.data)) * lpPrice.data + Number(getNumber(thorStaked.data)) * thorPrice.data
    : 0;

  return [tvl, thorPrice];
};

const HeadCardDesktop = ({
  thorPrice,
  lpPrice,
  isAllowed,
  pendingThor,
  userInfo,
  onWithdraw,
  tvlDecimals,
  tvlFloats,
  farmType,
}) => {
  return (
    <Grid container spacing={2} display={{ xs: 'none', sm: 'none', md: 'none', lg: 'flex' }}>
      <Grid item md={12} lg={6} sm={12} xs={12}>
        <Box
          sx={{
            background: 'linear-gradient(92.91deg, rgba(19, 22, 30, 0.76) 1.78%, rgba(19, 22, 30, 0.62) 99.64%)',
            borderRadius: '12px',
            paddingX: 1,
            paddingY: 4,
          }}
          height="240px"
        >
          <Box display={'flex'} alignItems="center">
            {/* <img src={imgFarm} alt="farm" /> */}
            <Typography marginLeft={3} variant="h4" sx={{ fontFamily: 'Kanit', color: 'white', opacity: 0.5 }}>
              Farm
            </Typography>
          </Box>
          <Container maxWidth="sm">
            <Box paddingX={0}>
              <Box>
                <Typography
                  marginLeft={0}
                  variant="subtitle1"
                  sx={{ fontFamily: 'Kanit', color: 'white', opacity: 0.5 }}
                >
                  Total Volume Locked
                </Typography>
              </Box>
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <Typography
                  marginLeft={0}
                  gutterBottom
                  sx={{
                    background: 'linear-gradient(112.98deg, #FFF4D1 8.47%, #F5D28F 23.3%, #675537 91.31%);',
                    fontFamily: 'Kanit',
                    backgroundClip: 'text',
                    WebkitBackgroundClip: 'text',
                    textFillColor: 'transparent',
                    fontStyle: 'normal',
                    WebkitTextFillColor: 'transparent',
                    fontWeight: 500,
                    fontSize: '72px',
                  }}
                >
                  ${tvlDecimals()}
                </Typography>
                <Typography
                  gutterBottom
                  sx={{
                    color: '#8c8b97',
                    fontFamily: 'Kanit',
                    fontStyle: 'normal',
                    fontWeight: 500,
                    fontSize: '32px',
                    marginTop: 2,
                    // marginTop: "-50px",
                  }}
                >
                  .{tvlFloats()}
                </Typography>
              </Box>
            </Box>
          </Container>
        </Box>
      </Grid>
      <Grid item lg={3} md={6} sm={12} xs={12}>
        <Box
          sx={{
            background: 'linear-gradient(92.91deg, rgba(19, 22, 30, 0.76) 1.78%, rgba(19, 22, 30, 0.62) 99.64%)',
            borderRadius: '12px',
            padding: '20px 16px',
          }}
          height="240px"
        >
          <Box display="flex" alignItems="center" width="100%" justifyContent="space-between">
            <Box>
              <Typography variant="subtitle1" sx={{ fontFamily: 'Kanit', color: 'white', opacity: 0.5 }}>
                Unclaimed
              </Typography>
            </Box>
            {isAllowed && (
              <Box marginLeft={2} sx={{ textAlign: 'right' }}>
                <CustomButton label="claim rewards" onClick={() => onWithdraw(0)} />
              </Box>
            )}
          </Box>
          <Box display={'flex'} alignItems="center" marginTop={2}>
            <img src={imgThor} alt="thor" width={'32px'} />
            <Typography
              marginLeft={2}
              variant="h4"
              sx={{
                background: 'linear-gradient(112.98deg, #FFF4D1 8.47%, #F5D28F 23.3%, #675537 91.31%);',
                fontFamily: 'Kanit',
                backgroundClip: 'text',
                WebkitBackgroundClip: 'text',
                textFillColor: 'transparent',
                fontStyle: 'normal',
                WebkitTextFillColor: 'transparent',
                fontWeight: 500,
              }}
            >
              {pendingThor?.data ? Number(getNumber(pendingThor.data)).toFixed(3) : 0}
            </Typography>
          </Box>
          <Box display={'flex'} alignItems="center">
            <Typography variant="subtitle2" sx={{ fontFamily: 'Kanit', color: 'white', opacity: 0.5 }}>
              USD
            </Typography>
            <Typography
              marginLeft={2}
              variant="subtitle2"
              sx={{
                color: 'white',
                fontFamily: 'Kanit',
                fontWeight: 500,
              }}
            >
              $
              {thorPrice?.data
                ? Number(thorPrice.data * pendingThor?.data ? getNumber(pendingThor.data) : 0).toFixed(2)
                : 0}
            </Typography>
          </Box>
        </Box>
      </Grid>
      <Grid item lg={3} md={6} sm={12} xs={12}>
        <Box
          sx={{
            background: 'linear-gradient(92.91deg, rgba(19, 22, 30, 0.76) 1.78%, rgba(19, 22, 30, 0.62) 99.64%)',
            borderRadius: '12px',
            padding: '20px 16px',
          }}
          height="240px"
        >
          <Box display="flex" alignItems="center" width="100%" justifyContent="space-between">
            <Box>
              <Typography variant="subtitle1" sx={{ fontFamily: 'Kanit', color: 'white', opacity: 0.5 }}>
                My Staked
              </Typography>
            </Box>
            <Box sx={{ textAlign: 'right' }}>
              {parseInt(farmType) === 1 && (
                <CustomButton
                  label="buy thor"
                  onClick={() =>
                    window.open(
                      'https://traderjoexyz.com/trade?outputCurrency=0x8f47416cae600bccf9530e9f3aeaa06bdd1caa79',
                    )
                  }
                />
              )}
              {parseInt(farmType) === 0 && (
                <CustomButton
                  label="add thor-avax lp"
                  onClick={() =>
                    window.open('https://traderjoexyz.com/pool/0x8f47416cae600bccf9530e9f3aeaa06bdd1caa79/AVAX')
                  }
                />
              )}
            </Box>
          </Box>
          <Box display={'flex'} alignItems="center" marginTop={2}>
            <img src={imgThor} alt="thor" width={'32px'} />
            <Typography
              marginLeft={2}
              variant="h4"
              sx={{
                background: 'linear-gradient(112.98deg, #FFF4D1 8.47%, #F5D28F 23.3%, #675537 91.31%);',
                fontFamily: 'Kanit',
                backgroundClip: 'text',
                WebkitBackgroundClip: 'text',
                textFillColor: 'transparent',
                fontStyle: 'normal',
                WebkitTextFillColor: 'transparent',
                fontWeight: 500,
              }}
            >
              {userInfo.data && getNumber(userInfo.data.amount)}{' '}
            </Typography>
          </Box>
          <Box display={'flex'} alignItems="center">
            <Typography variant="subtitle2" marginTop={1} sx={{ fontFamily: 'Kanit', color: 'white', opacity: 0.5 }}>
              USD
            </Typography>
            <Typography
              marginLeft={2}
              variant="subtitle2"
              sx={{
                color: 'white',
                fontFamily: 'Kanit',
                fontWeight: 500,
              }}
            >
              {userInfo.data && lpPrice.data && (Number(getNumber(userInfo.data.amount)) * lpPrice.data).toFixed(2)}
            </Typography>
          </Box>
        </Box>
      </Grid>
    </Grid>
  );
};

const HeadCardMobile = ({
  thorPrice,
  lpPrice,
  isAllowed,
  pendingThor,
  userInfo,
  onWithdraw,
  tvlDecimals,
  tvlFloats,
  farmType,
}) => {
  return (
    <Box
      className={styles.headCard}
      sx={{
        background: 'linear-gradient(92.91deg, rgba(19, 22, 30, 0.76) 1.78%, rgba(19, 22, 30, 0.62) 99.64%)',
        borderRadius: '12px',
        // padding: 4,
      }}
      display={{ xs: 'block', sm: 'block', md: 'block', lg: 'none' }}
    >
      <Box>
        <Typography variant="subtitle1" sx={{ fontFamily: 'Kanit', color: 'white', opacity: 0.5 }}>
          Total Volume Locked
        </Typography>
        <Box sx={{ display: 'flex', alignItems: 'center', marginTop: '-10px' }}>
          <Typography
            gutterBottom
            sx={{
              background: 'linear-gradient(112.98deg, #FFF4D1 8.47%, #F5D28F 23.3%, #675537 91.31%);',
              fontFamily: 'Kanit',
              backgroundClip: 'text',
              WebkitBackgroundClip: 'text',
              textFillColor: 'transparent',
              fontStyle: 'normal',
              WebkitTextFillColor: 'transparent',
              fontWeight: 500,
              fontSize: '40px',
            }}
          >
            ${tvlDecimals()}
          </Typography>
          <Typography
            gutterBottom
            sx={{
              color: '#8c8b97',
              fontFamily: 'Kanit',
              fontStyle: 'normal',
              fontWeight: 500,
              fontSize: '24px',
              marginTop: '8px',
            }}
          >
            .{tvlFloats()}
          </Typography>
        </Box>
      </Box>
      <Box
        sx={{
          width: '100%',
          height: '0px',
          border: '1px solid rgba(255, 255, 255, 0.1)',
        }}
      ></Box>
      <Box className={styles.headCardContainer}>
        <Box sx={{ flex: 1 }}>
          <Box marginTop={2}>
            {isAllowed && (
              <Box sx={{ textAlign: 'right' }}>
                <CustomButton label="claim rewards" onClick={() => onWithdraw(0)} />
              </Box>
            )}
            <Typography variant="subtitle1" sx={{ fontFamily: 'Kanit', color: 'white', opacity: 0.5 }}>
              Unclaimed
            </Typography>
          </Box>
          <Box display={'flex'} alignItems="center">
            <img src={imgThor} alt="thor" width={'24px'} />
            <Typography
              sx={{
                marginLeft: '10px',
                background: 'linear-gradient(112.98deg, #FFF4D1 8.47%, #F5D28F 23.3%, #675537 91.31%);',
                fontFamily: 'Kanit',
                backgroundClip: 'text',
                WebkitBackgroundClip: 'text',
                textFillColor: 'transparent',
                fontStyle: 'normal',
                WebkitTextFillColor: 'transparent',
                fontWeight: 500,
                fontSize: '24px',
              }}
            >
              {pendingThor?.data ? Number(getNumber(pendingThor.data)).toFixed(3) : 0}
            </Typography>
          </Box>
          <Box display={'flex'} alignItems="center">
            <Typography
              variant="subtitle2"
              sx={{
                fontFamily: 'Kanit',
                color: 'white',
                opacity: 0.5,
                fontSize: '12px',
              }}
            >
              USD
            </Typography>
            <Typography
              marginLeft="10px"
              sx={{
                color: 'white',
                fontFamily: 'Kanit',
                fontWeight: 500,
                fontSize: '12px',
              }}
            >
              $
              {thorPrice?.data
                ? Number(thorPrice.data * pendingThor?.data ? getNumber(pendingThor.data) : 0).toFixed(2)
                : 0}
            </Typography>
          </Box>
        </Box>
        <Box sx={{ flex: 1, marginLeft: '30px' }}>
          <Box marginTop={2} marginBottom={1}>
            <Typography variant="subtitle1" sx={{ fontFamily: 'Kanit', color: 'white', opacity: 0.5 }}>
              My Staked
            </Typography>
          </Box>
          <Box display={'flex'} alignItems="center">
            <img src={imgThor} alt="thor" width={'24px'} />
            <Typography
              sx={{
                marginLeft: '10px',
                background: 'linear-gradient(112.98deg, #FFF4D1 8.47%, #F5D28F 23.3%, #675537 91.31%);',
                fontFamily: 'Kanit',
                backgroundClip: 'text',
                WebkitBackgroundClip: 'text',
                textFillColor: 'transparent',
                fontStyle: 'normal',
                WebkitTextFillColor: 'transparent',
                fontWeight: 500,
                fontSize: '24px',
              }}
            >
              {userInfo.data && getNumber(userInfo.data.amount)}{' '}
            </Typography>
          </Box>
          <Box display={'flex'} alignItems="center">
            <Typography
              marginTop={1}
              variant="subtitle2"
              sx={{
                fontFamily: 'Kanit',
                color: 'white',
                opacity: 0.5,
                fontSize: '12px',
              }}
            >
              USD
            </Typography>
            <Typography
              marginLeft="10px"
              sx={{
                color: 'white',
                fontFamily: 'Kanit',
                fontWeight: 500,
                fontSize: '12px',
              }}
            >
              {userInfo.data && lpPrice.data && (Number(getNumber(userInfo.data.amount)) * lpPrice.data).toFixed(2)}
            </Typography>
          </Box>
          <Box className={styles.headBtn} sx={{ textAlign: 'right' }} marginTop={2}>
            {parseInt(farmType) === 1 && (
              <CustomButton
                label="buy thor"
                onClick={() =>
                  window.open(
                    'https://traderjoexyz.com/trade?outputCurrency=0x8f47416cae600bccf9530e9f3aeaa06bdd1caa79',
                  )
                }
              />
            )}
            {parseInt(farmType) === 0 && (
              <CustomButton
                label="add thor-avax lp"
                onClick={() =>
                  window.open('https://traderjoexyz.com/pool/0x8f47416cae600bccf9530e9f3aeaa06bdd1caa79/AVAX')
                }
              />
            )}
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

const HeadCard = ({ farmType }) => {
  const web3Context = useSelector((state) => state.web3.web3context);
  const ethereum = web3Context?.library;

  const [tvl, thorPrice] = useTVL(ethereum);

  const poolConfig = pools[parseInt(farmType)];
  const pendingThor = useGetPendingTHOR(poolConfig.pid);
  const userInfo = useGetUserInfo(poolConfig.pid);
  const { onWithdraw, isWithdrawing } = useWithdraw(poolConfig.pid);
  const allowance = useGetAllowance(poolConfig.address);
  const totalSupply = useGetTotalSupply(poolConfig.address);
  const lpPrice = useQuery(
    ['lpPrice', poolConfig.pid, poolConfig.symbol],
    () => {
      return poolConfig.getPrice(ethereum);
    },
    {
      refetchInterval: 60000 * 10,
      enabled: Boolean(totalSupply.data && ethereum),
    },
  );

  const isAllowed = allowance.data && new BigNumber(allowance.data).isGreaterThan(0);

  const tvlDecimals = () => {
    if (!tvl) return 0;
    return tvl.toString().split('.')[0];
  };

  const tvlFloats = () => {
    if (!tvl) return 0;
    return tvl.toFixed(2).toString().split('.')[1];
  };

  return (
    <>
      <HeadCardDesktop
        thorPrice={thorPrice}
        lpPrice={lpPrice}
        isAllowed={isAllowed}
        pendingThor={pendingThor}
        userInfo={userInfo}
        onWithdraw={onWithdraw}
        tvlDecimals={tvlDecimals}
        tvlFloats={tvlFloats}
        farmType={farmType}
      />
      <HeadCardMobile
        thorPrice={thorPrice}
        lpPrice={lpPrice}
        isAllowed={isAllowed}
        pendingThor={pendingThor}
        userInfo={userInfo}
        onWithdraw={onWithdraw}
        tvlDecimals={tvlDecimals}
        tvlFloats={tvlFloats}
        farmType={farmType}
      />
    </>
  );
};

export { HeadCard };
